import valera from '../../../../../static/videos/main-swiper/valera.mp4'
import corp from '../../../../../static/videos/main-swiper/corp.mp4'
import waves from '../../../../../static/videos/main-swiper/waves.mp4'
import group from '../../../../../static/videos/main-swiper/group.mp4'
import merch from '../../../../../static/videos/main-swiper/merch.mp4'
import { Icons } from 'src/ui/icons'

export const videos = [
  { src: corp },
  { src: merch },
  { src: waves },
  { src: valera },
  { src: group },
]

export const achivements = [
  {
    icon: Icons.ForbesIcon,
    title: 'Золотая группа',
    subtitle: 'Forbes — работодатели 2024',
    description: 'Вхождение в высшую категорию рейтинга',
    link: 'https://www.forbes.ru/ratings/best-employers/2025',
  },
  {
    icon: Icons.HhIcon,
    title: '2-е место',
    subtitle: 'Лучшие IT-работодатели России',
    description: 'Среди компаний среднего размера',
    link:
      'https://rating.hh.ru/history/rating2025/summary?tab=regular&sphere=%D0%98%D0%A2%E2%80%91%D0%BA%D0%BE%D0%BC%D0%BF%D0%B0%D0%BD%D0%B8%D0%B8',
  },
  {
    icon: Icons.HrIcon,
    title: 'Лучший HR-бренд',
    subtitle: 'Лидеры цифровизации',
    description: 'Признание HR-экспертизы компании',
    link: 'https://rating.msbinfo.ru/',
  },
  {
    icon: Icons.RbkIcon,
    title: '1-е место',
    subtitle: 'Работодатель РБК 2024',
    description: 'Лидер рейтинга работодателей',
    link:
      'https://drive.google.com/file/d/19ZJyFndjq13dzZcASEcRtzwdBuMIdn4O/view',
  },
  {
    icon: Icons.RuwardIcon,
    title: '1-е место',
    subtitle: 'RUWARD AWARD 2024',
    description: 'Лучший HR-бренд среди мобильных разработчиков',
    link: 'https://ruward.ru/award/2024/84487/',
  },
]
